import { VariantProps, cva } from 'class-variance-authority';
import { useState } from 'react';
import { twMerge } from 'tailwind-merge';
import { Icon } from '../Icon/Icon';
import { IconButton } from '../IconButton/IconButton';
import { Text } from '../Text/Text';

const collapsible = cva('flex flex-col w-full');

type CollapsibleProps = VariantProps<typeof collapsible> & {
  text?: string;
  trigger?: React.ReactNode;
  children?: React.ReactNode;
};

export const Collapsible = ({ text, trigger, children }: CollapsibleProps) => {
  const [collapsed, setCollapsed] = useState(true);
  const iconName = collapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up';

  const handleClick = () => {
    setCollapsed((collapsed) => !collapsed);
  };

  return (
    <div className={twMerge(collapsible())}>
      <div
        className="flex items-center justify-between cursor-pointer"
        onClick={handleClick}
        aria-hidden="true"
      >
        {trigger || <Text size="bodyL">{text}</Text>}
        <IconButton size="small" intent="ghost">
          <Icon name={iconName} size="large" />
        </IconButton>
      </div>
      {!collapsed && children}
    </div>
  );
};
